import HasEventListeners from 'dashboard-js/mixins/HasEventListeners'

var base = require('kiosk/users')

Vue.component('spark-kiosk-users', {
    mixins: [base, HasEventListeners],

    mounted() {
        this.listen(document, 'keydown', e => {
            if (this.showingUserProfile && e.keyCode === 27) {
                this.navigateToSearch()
            }
        })
    },

    methods: {
        search() {
            this.searching = true
            this.noSearchResults = false

            axios.post('/spark/kiosk/users/search', this.searchForm.data()).then(response => {
                this.searchResults = response.data
                this.noSearchResults = this.searchResults.length === 0

                this.searching = false
            })
        },

        getPlans() {
            // silence is golden
        },
    },
})
